import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as spaceLite from '../space-lite'

export const RESOURCE = {
  payload: {
    alias: 'space-lite:record-details',
    appAlias: spaceLite.RESOURCE.payload.alias,
    description: 'Single Record Details page',
    name: 'Record Details',
    page: { id: prebuilt.Page.Id.SpaceLiteRecordDetails },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
